import {
  AddressListRes,
  OrderDetail,
  PackageSearch,
  CancelSubscriptionParams,
  SKU,
  SubscriptionDetailResponse,
  SubscriptionPriceSearch,
  GetInvoicePdfUrlRes,
} from '@/api/interface/order';

import { getAPIBaseUrl } from '../utils/url';

import { get, post } from './axios';
// import {
//   IGetApiStudentOrderMyOrderPageNumRequest,
//   IGetApiStudentOrderMyOrderPageNumResponse,
//   IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeRequest,
//   IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeResponse,
//   IPostApiStudentOrderCouponSearchPageNumPageSizeRequest,
//   IPostApiStudentOrderCouponSearchPageNumPageSizeResponse,
// } from './interface/order_subscription';
import {
  IGetApiStudentOrderMyOrderPageNumRequest,
  IGetApiStudentOrderMyOrderPageNumResponse,
  IPostApiStudentOrderCouponSearchPageNumPageSizeRequest,
  IPostApiStudentOrderCouponSearchPageNumPageSizeResponse,
} from './interface/order-center';
import {
  IGetApiStudentMasterV2CourseFeaturedDetailRequest,
  IGetApiStudentMasterV2CourseFeaturedDetailResponse,
  IGetApiStudentMasterV2CourseFeaturedV3Request,
  IGetApiStudentMasterV2CourseFeaturedV3Response,
  IGetApiStudentMasterV2DeductionsUuidRequest,
  IGetApiStudentMasterV2DeductionsUuidResponse,
  IPostApiStudentMasterV2CourseFeaturedRequest,
  IPostApiStudentMasterV2CourseFeaturedResponse,
  IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeRequest,
  IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeResponse,
} from './interface/student';

export const COMMON_API = process.env.NEXT_PUBLIC_COMMON_API_DOMAIN || '';

export const COMMON_API_HOST = getAPIBaseUrl(COMMON_API);

/**
 *  订单列表
 * @returns
 */
export const queryOrderList = (pageNum: number) => {
  return get<
    IGetApiStudentOrderMyOrderPageNumRequest,
    IGetApiStudentOrderMyOrderPageNumResponse
  >(`/api/student/order/my_order/${pageNum}`);
};

/**
 *  获取订单发票pdf url
 * @returns
 */
export const getInvoicePdfUrl = (orderId: string) => {
  return get<GetInvoicePdfUrlRes, GetInvoicePdfUrlRes>(
    `${process.env.NEXT_PUBLIC_WK_GATEWAY_API_DOMAIN}/ms-e-commerce/api/invoice/${orderId}/pdf/access`,
  );
};

/**
 *  扣费明细
 * @returns
 */
export const getDeductions = (uuid: string) => {
  return get<
    IGetApiStudentMasterV2DeductionsUuidRequest,
    IGetApiStudentMasterV2DeductionsUuidResponse
  >(`/api/student/master/v2/deductions/${uuid}`);
};

/**
 * 查询国家列表
 */

export const getCountrys = async (): Promise<Array<AddressListRes>> => {
  const data = (await get(
    `${COMMON_API_HOST}/public/world_city?language=EN`,
  )) as any;
  return data?.filter((item: any) => item.iso2 !== 'CN') || [];
};

/**
 * 根据ip地址获取当前地址信息
 */

export const getAddress = (): Promise<any> => {
  return get(`${COMMON_API_HOST}/public/ip/ipInfoAGGCms`);
};

/**
 * 我的订阅列表
 */

export const getMySubscription = (pageIndex: number, pageSize: number) => {
  return post<
    IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeRequest,
    IPostApiStudentMasterV2MySubscriptionPageIndexPageSizeResponse
  >(`/api/student/master/v2/my_subscription/${pageIndex}/${pageSize}`);
};

/**
 * 搜索代金券
 */
export const getVouchers = (
  pageNum: number,
  pageSize: number,
  data: { studentCode: string; status: 'UNUSED' | 'USED' },
) => {
  return post<
    IPostApiStudentOrderCouponSearchPageNumPageSizeRequest,
    IPostApiStudentOrderCouponSearchPageNumPageSizeResponse
  >(`/api/student/order/coupon/search/${pageNum}/${pageSize}`, data);
};
/**
 * 首页-精选课程
 */
export const getPackages = () => {
  return post<
    IPostApiStudentMasterV2CourseFeaturedRequest,
    IPostApiStudentMasterV2CourseFeaturedResponse
  >(`/api/student/master/v2/course/featured`);
};
/**
 * 3.0订阅详情
 * @returns
 */
export const getFeaturedDetail = () => {
  return get<
    IGetApiStudentMasterV2CourseFeaturedDetailRequest,
    IGetApiStudentMasterV2CourseFeaturedDetailResponse
  >(`/api/student/master/v2/course/featured/detail`);
};

/**
 * 精选课包分页搜索
 */

export const getCoursePackagesByPage = (
  pageNum: number,
  data: PackageSearch,
): Promise<any> => {
  return post(`/api/student/master/v2/course/CoursePackages/${pageNum}`, data);
};

/**
 * 取消订阅
 */

export const cancelSubscription = (
  data: CancelSubscriptionParams,
): Promise<any> => {
  return post(`/api/student/master/v2/apply_cancel_subscription`, data);
};

/**
 * 获取订阅详情
 */

export const getSubscriptionDetail = (
  uuid: string,
): Promise<SubscriptionDetailResponse> => {
  return post(`/api/student/master/v2/subscription_detail/${uuid}`);
};

/**
 * 获取订单详情
 * @param uuid
 * @returns
 */
export const getOrderDetail = (uuid: string): Promise<OrderDetail> => {
  return get(`/api/student/order/detail/${uuid}`);
};

/**
 * 3.8 获取订阅价格
 */

export const fetchActualPaymentAmount = (
  data: SubscriptionPriceSearch,
): Promise<SKU> => {
  return post(`/api/student/order/subscribe/sku/price`, data);
};

// 订阅3.0入口
export const getSubscriptionData = () => {
  return get<
    IGetApiStudentMasterV2CourseFeaturedV3Request,
    IGetApiStudentMasterV2CourseFeaturedV3Response[]
  >(`/api/student/master/v2/gs/course/featured/V3`);
};

/**
 * 解绑卡片
 * @param consentId
 * @returns
 */
export const postUnbindCard = (consentId: string): Promise<any> => {
  return post(
    `/api/student/order/card/disable/${consentId}`,
    {},
    {
      skipErrorHandler: true,
    },
  );
};
